<template>
  <form
    class="mini-calendar__search"
    role="search"
    aria-labelledby="searchFormLabel"
    @submit.prevent
  >
    <label id="searchFormLabel" for="searchTerm">Search</label>
    <input
      type="text"
      id="searchTerm"
      v-model.trim="searchValue"
      name="searchTerm"
      aria-label="Enter Search"
      @keyup.enter="onEnter"
    />

    <button type="submit" @click="onEnter">
      <IconSearch /><span class="visible-for-screen-readers">Search</span>
    </button>
  </form>
</template>

<script>
import IconSearch from "./icon/icon-search.vue";
import { mapActions, mapGetters } from "vuex";
import { getFilteredEvents } from "./../api";
import moment from "moment";

export default {
  name: "MiniCalenderSearch",
  components: {
    IconSearch,
  },
  computed: {
    ...mapGetters(["search"]),
  },
  data() {
    return {
      searchValue: "",
    };
  },
  watch: {
    search(newValue) {
      if (!newValue) {
        this.searchValue = "";
      }
    },
  },
  methods: {
    onEnter() {
      this.setLoading(true);
      const queryString = Object.entries(this.$store.state.selectedCategories || {})
      .flatMap(([key, terms]) => terms.map((term) => `${key}=${term}`))
      .join("&");
      const filtersQueryString = queryString || "";
      const searchTerm = this.searchValue;
      const dateRange = this.$store.getters.date_range || {};

      const currentDate = moment().format("YYYY-MM-DD");
      const startDate = dateRange.start || currentDate;
      const endDate = dateRange.end || "";

      this.setSearch({ search: searchTerm });

      getFilteredEvents(startDate, endDate, filtersQueryString, 1, searchTerm)
        .then((response) => {
          if (response) {
            this.setEventList({
              eventlist: response.data ? response.data : [],
              total: response.query.total,
            });
          }
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
      },
    ...mapActions(["setSearch", "setEventList", "setLoading"]),
  },
};
</script>


